<ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup">
        <ion-item>
            <h4>{{ getText(question.globalizationConfig, "title") }}</h4>
            <ion-datetime
                    presentation="date"
                    [locale]="'pt-BR'"
                    [formControlName]="'field' + question.currentIndex + (isManagerComment ? 'Comment' : '')"
                    (ionChange)="setDateFromEvent($event, question.currentIndex)"
            ></ion-datetime>
        </ion-item>
    </form>
</ng-container>